import React from 'react';

import file from '../../../assets/excelFile.svg'
import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions, ActiveElement, ChartEvent } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'react-chartjs-2';
import { SCREENING_MEASURES_COLOR } from '../../../utils/Analytics';
import { Card, CardContent, CardHeader, Divider, Popover, Theme, Typography, createStyles, withStyles } from '@material-ui/core';
import { Info } from '@material-ui/icons';
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const CardPadding = '12px 16px';
const useStyles = (theme: Theme) =>
  createStyles({
    root: {
      padding: CardPadding
    },
    popover: {
      pointerEvents: 'none',
      '& *': {
        fontFamily: 'Nunito',
      }
    },
    infoIcon: {
      lineHeight: 0,
    }
  });

interface SecurityMeasuresProps {
  classes: any;
  measures: any[string];
  scrMeasures: string[];
  handleChartClick: (event: ChartEvent, elements: ActiveElement[]) => void;
  handleExport: (type: string) => void;
};

const SecurityMeasures = (props: SecurityMeasuresProps) => {

  const { classes } = props;

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
    document.body.classList.add(commonStyles.pr24)
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    document.body.classList.remove(commonStyles.pr24)
  };

  const data = {
    labels: props.scrMeasures,
    datasets: [
      {
        label: 'Security Measures Applied',
        data: props.scrMeasures.map((m: string) => {
          return props.measures[m] || 0;
        }),
        backgroundColor: props.scrMeasures.map((m: string) => {
          return SCREENING_MEASURES_COLOR[m] || '#000';
        }),
      },
    ],
  };

  const graphOptions: ChartOptions = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            return context.label;
          }
        }
      },
      legend: {
        fullSize: true,
        display: true,
        position: 'top'
      },
      datalabels: {
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr = ctx.chart.data.datasets[0].data;
          dataArr.map(data => {
            if (typeof data == 'number')
              sum += data;
          });
          let result = value * 100 / sum
          let percentage = (result).toFixed(0) + "%";
          if (result > 0) {
            return percentage;
          } else {
            return '';
          }
        },
        color: '#fff',
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    onClick: props.handleChartClick
  };

  const open = Boolean(anchorEl);
  return (
    <div className={`${styles.wtOuterGridItems}`}>
      <div className={`${commonStyles.fSpaceBtw} ${commonStyles.flexWrap}`}>
        <div className={`${commonStyles.dFlex} ${commonStyles.gap10}`}>
          <h5 className={styles.heading}>Security Measures Applied</h5>
          <Typography
            component='div'
            aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            className={classes.infoIcon}
          >
            <Info color='primary' />
          </Typography>
        </div>
        <div className={`${styles.fileImg}`} onClick={() => props.handleExport('measures')}>
          <img src={file} alt="file" />
        </div>
      </div>
      <div className={styles.graphWrapper}>
        <div className={styles.pieWrapper}>
          <Chart type={'pie'} height={300} data={data} options={graphOptions} />
        </div>
      </div>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Card>
          <CardHeader
            title={<Typography variant="body2">
              Note
            </Typography>}
            classes={{ root: classes.root }}
          >
          </CardHeader>
          <Divider />
          <CardContent classes={{ root: classes.root }}>
            <Typography variant="body2" gutterBottom color="textSecondary" component="p">
              Click the graph to see methods applied.
            </Typography>
          </CardContent>
        </Card>
      </Popover>
    </div>
  );
};

export default withStyles(useStyles)(SecurityMeasures);